<div class="card">
  <app-header titulo="Ordem" descricao=""></app-header>

  <div class="grid p-fluid" *ngIf="ordem != null">
    <div class="col-8">
      <b>Instância:</b> {{ ordem.instancia }} <br />
      <b>OS:</b> {{ ordem.noOs }} <br />
      <b>Situação:</b> {{ statusOrdem(ordem.fgSituacao) }}
      <br />
      <b>Fazenda:</b> {{ ordem.deUpnivel1 }}
      <br />
      <b>UF:</b> {{ ordem.cdUf }} <br />
    </div>
    <div class="col-4">
      <a [routerLink]="realizaMovimentao(ordem.fgSituacao) ? null : ['/painelinsumos', 'transferencia', ordem.id, 'R']"
        ><p-button
          icon="pi pi-arrow-up-right"
          severity="success"
          label="Retirada"
          [disabled]="realizaMovimentao(ordem.fgSituacao)"
          *appHasPermission="'ACTION_PI_RETIRAR'"
        ></p-button
      ></a>
      <a [routerLink]="realizaMovimentao(ordem.fgSituacao) ? null : ['/painelinsumos', 'transferencia', ordem.id, 'D']"
        ><p-button
          icon="pi pi-arrow-down-left"
          severity="danger"
          label="Devolução"
          [disabled]="realizaMovimentao(ordem.fgSituacao)"
          *appHasPermission="'ACTION_PI_DEVOLVER'"
        ></p-button
      ></a>
      <a [routerLink]="realizaMovimentao(ordem.fgSituacao) ? null : ['/painelinsumos', 'transferencia', ordem.id, 'T']"
        ><p-button
          icon="pi pi-arrow-right-arrow-left"
          severity="primary"
          label="Transferência"
          [disabled]="realizaMovimentao(ordem.fgSituacao)"
          *appHasPermission="'ACTION_PI_TRANSFERIR'"
        ></p-button
      ></a>
    </div>
  </div>

  <div class="mt-3" *ngIf="ordem != null">
    <p-table
      [value]="ordem.itens"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
      [resizableColumns]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th colspan="4"></th>
          <th colspan="10">Quantidades</th>
          <th colspan="2">Saldos</th>
        </tr>
        <tr>
          <th>Data</th>
          <th>Insumo</th>
          <th>Descrição</th>
          <th>Unidade</th>
          <th>Disp Estoque</th>
          <th>Compromissada</th>
          <th>Original OS</th>
          <th>Ajustada OS</th>
          <th>Compromissada OS</th>
          <th>Retirada</th>
          <th>Recebida</th>
          <th>Transferida</th>
          <th>Baixada PIMS</th>
          <th>Devolvida</th>
          <th>À receber</th>
          <th>Baixa</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ formatDate(item.dtRefer) }}</td>
          <td>{{ item.cdInsumo }}</td>
          <td>{{ item.deInsumo }}</td>
          <td>{{ item.cdUnimed }}</td>
          <td><div *ngIf="loadingEstoqueERP; else elseBlock"><p-progressSpinner ariaLabel="loading" strokeWidth="2" styleClass="w-1rem h-1rem"></p-progressSpinner></div><ng-template #elseBlock>{{ estoqueMaterialErp[item.cdInsumoErp]?.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</ng-template></td>
          <td>{{ item.qtCompromissada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ item.qtOriginal.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ item.qtAjustada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ item.qtCompromissadaOs.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td style="color: green">{{ item.qtRetirada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td style="color: green">{{ item.qtRecebida.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td style="color: red">{{ item.qtEnviada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ insConsumidos[item.cdInsumo]?.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td>
          <td>{{ item.qtDevolvida.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ item.qtSaldoReceber.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
          <td>{{ (item.bloqueado ? 0 : (item.qtSaldoBaixa - getBaixado(item.cdInsumo))).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="mt-4">
    <p-fieldset legend="Remessas">
        <p-table [value]="remessas" dataKey="id" >
          <ng-template pTemplate="header">
            <tr>
              <th></th>

              <th>Data Remessa</th>
              <th>Tipo</th>
              <th>OS Origem</th>
              <th>OS Destino</th>
              <th>Deposito Origem</th>
              <th>Deposito Destino</th>
              <th>Posição</th>
              <th>Status</th>
              <th>Reserva</th>
              <th>Mensagem</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-remessa let-ri="rowIndex" let-expanded="expanded">
            <tr [ngClass]="{'bg-transferencia': remessa.tipo == 'T', 'bg-devolucao': remessa.tipo == 'D', 'bg-retirada': remessa.tipo == 'R', 'bg-mat-cadastro': remessa.tipo == 'M'}">
              <td><button type="button" pButton [pRowToggler]="remessa" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button></td>
              <td>{{ remessa.dtRemessa | date: 'dd/MM/yyyy HH:mm'}} <br /> Usuário: {{ remessa.usuario }}</td>
              <td>{{ getDescricaoTipo(remessa.tipo) }}</td>
              <td>{{ remessa.osOrigem }}</td>
              <td>{{ remessa.osDestino }}</td>
              <td>{{ remessa.cdDepositoOrigem }}</td>
              <td>{{ remessa.cdDepositoDestino }}</td>
              <td>{{ remessa.cdPosicao }}</td>
              <td><p-tag [value]="getStatusReserva(remessa.status)" [severity]="getStatusReservaSeverity(remessa.status)"  /></td>
              <td>{{ remessa.noReserva }}

              </td>
              <td>{{ remessa.deMensagemInteg }}</td>
              <td>
                <span *appHasPermission="'ACTION_PI_ATENDER_RESERVA'">
                  <p-button size="small" severity="succes" label="Atender" (click)="abreAtendimentoDialog(remessa)" [disabled]="(remessa.status == 'AT' || remessa.status == 'CA')" *ngIf="ordem.cdUf == 'GO'"></p-button> <br />
                </span>
                <span *appHasPermission="'ACTION_PI_CANCELAR_RESERVA'">
                  <p-button size="small" label="Cancelar" severity="danger" (click)="cancelarRemessa($event, remessa)" [disabled]="remessa.status == 'AT' || remessa.status == 'CA' || remessa.status == 'AP'"></p-button>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-remessa>
            <tr>
              <td colspan="8">
                <div class="pr-3 pb-3 pl-3 ">
                  <p-table [value]="remessa.itens">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Cód Material</th>
                        <th>Material</th>
                        <th>Quantidade</th>
                        <th>Status</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                      <tr>

                        <td>{{ item.cdMaterialPims }}</td>
                        <td>{{ item.deMaterialPims }}</td>
                        <td>{{ item.qtMovimento.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  }}</td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
    </p-fieldset>
  </div>
</div>

<app-atendimento-dialog
    [visivel]="abreAtendimento"
    (fechar)="escondeAtendimentoDialog()"
    [remessa]="remessaSelecionada"
  ></app-atendimento-dialog>

  <p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
